import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { ShortPaymentModel } from "../models/PaymentModels";
import { PaymentService } from "../services/PaymentService";

export function usePaymentVM() {
    const paymentService = new PaymentService();

    const [payment, setPayment] = useState<ShortPaymentModel | null>(null);
    const [payments, setPayments] = useState<ShortPaymentModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const [loading, setLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const getList = () => {
        setLoading(true);
        setPayments([]);
        setListHash(Utils.getRandomKey());

        const request = paymentService.getList();

        DataUtils.onRequest(request, onSearchResult);
    }

    const onSearchResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const payments = result.data as ShortPaymentModel[];
            setPayments(payments);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    //const get = (id: string) => {
    //    setLoading(true);
    //    setPayment(null);
    //    const request = paymentService.get(id);
    //    DataUtils.onRequest(request, onGetResult);
    //}

    //const onGetResult = (result: IDataResult) => {
    //    const payment = result.data as ShortPaymentModel | null | undefined;

    //    if (payment != null) {
    //        setPayment(payment);
    //    }

    //    setLoading(false);
    //}

    return {
        payment, setPayment,
        payments,
        listHash,

        loading, setLoading,
        showDetail, setShowDetail,

        getList,
        //get
    }
}